import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './styles.module.css';
import { Typography } from '@mui/material';

/**
 * TaskHeader component - Displays machine group image and information
 */
export default function TaskHeader({ taskData }) {
  const { t } = useTranslation();
  if (!taskData) return null;

  return (
    <div className={styles.header}>
      <img
        src={`${process.env.REACT_APP_BASE_URL}machine-groups/image/${taskData.groupImage}`}
        alt=""
        style={{ maxWidth: '90px', maxHeight: '68px' }}
      />
      <div className={styles.title}>
        <div>
          <Typography color={'#868686'}>{t('generic.machineGroup')}:</Typography>{' '}
          <Typography fontWeight={500}>{taskData.groupName}</Typography>
        </div>

        <div>
          <Typography color={'#868686'}>{t('generic.machine')}:</Typography>{' '}
          <Link
            to={`/machines/${taskData.machineId}`}
            style={{
              textDecoration: 'none',
              color: 'inherit',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
            onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
          >
            <Typography
              fontWeight={500}
              component="span"
              sx={{
                '&:hover': {
                  textDecoration: 'underline',
                  color: 'primary.main'
                }
              }}
            >
              {taskData.machineNumber} {taskData.machineName}
            </Typography>
          </Link>
        </div>
      </div>
    </div>
  );
}
